import React, { Component } from 'react';
import {
  InstantSearch,
  Hits,
  RefinementList,
  Pagination,
  Highlight,
  ClearRefinements,
  CurrentRefinements,
  connectSearchBox,
  SortBy,
  Configure,
  connectCurrentRefinements,
} from 'react-instantsearch-dom';
/* import algoliasearch from 'algoliasearch'; */
import algoliasearch from 'algoliasearch/lite';
import qs from 'qs';
import PropTypes from 'prop-types';
import Media from 'react-media';
/* import FilterMenus from '/src/components/filter-menus'; */
import SearchResultStats from '/src/components/SearchResultStats';
import Router from '/src/components/Router';
import AlgoliaHits from '/src/components/AlgoliaHits';
import Loader from "react-loader-spinner";
import GitHubImages from "../components/GitHubImages"
import { Switch, Tooltip, Drawer, Button, Affix } from 'antd';
import {
  Route,
  BrowserRouter,
  StaticRouter,
  browserHistory,
} from 'react-router-dom';
import AlgoliaInstantSearchCreateURLRefinementLists from '/src/components/AlgoliaInstantSearchCreateURLRefinementLists';




class SearchBox extends Component {
  timerId = null;

  state = {
    value: this.props.currentRefinement
  };

  onChangeDebounced = event => {
    const { refine, delay } = this.props;
    const value = event.currentTarget.value;

    clearTimeout(this.timerId);
    this.timerId = setTimeout(() => refine(value), delay);

    this.setState(() => ({
      value
    }));
  };

  render() {
    const { value } = this.state;

    return (
      <div className="searchInput-wrap">
        <input
          value={value}
          onChange={this.onChangeDebounced}
          placeholder="Search for champs by name, rarity, type, faction or faction alliance..."
        />
      </div>
    );
  }
}




const DEBOUNCE_TIME = 700;

/* const createURL = (state) => `?${qs.stringify(state)}`;

const searchStateToUrl = (props, searchState) =>
  searchState ? `${props.location.pathname}${createURL(searchState)}` : '';

const urlToSearchState = (location) => qs.parse(location.search.slice(1)); */


/* const createURL = state => `?${qs.stringify(state)}`;

const searchStateToUrl = (location, searchState) =>
  searchState ? `${location.pathname}${createURL(searchState)}` : '';

const urlToSearchState = location => qs.parse(location.search.slice(1)); */

function onChange(checked) {}

/* const algolia = {
  appId: 'I86ZC6FOFN',
  searchOnlyApiKey: '853137545a320556e09bd2cd3ea289ab',
  indexName: 'Champions',
}; */

const algolia = {
  appId: 'NJUY9DVNS9',
  searchOnlyApiKey: 'b4a83bd9cb99f935ac1a652bf5fa46d6',
  indexName: 'RaidTierList',
};

/* const algolia = {
  appId: process.env.ALGOLIA_APPLICATION_ID,
  searchOnlyApiKey: process.env.ALGOLIA_SEARCH_KEY,
  indexName: process.env.ALGOLIA_INDEX,
}; */

const searchClient = algoliasearch(algolia.appId, algolia.searchOnlyApiKey);

const DebouncedSearchBox = connectSearchBox(SearchBox);

class HomePageWithQueryParams extends Component {
  /* state = { visible: false, childrenDrawer: false, value: this.props.currentRefinement, searchState: urlToSearchState(this.props.location), lastLocation: this.props.location, }; */
/* 
  showDrawer = () => {
    this.setState({
      visible: true,
    });
  };

  onClose = () => {
    this.setState({
      visible: false,
    });
  };

  showChildrenDrawer = () => {
    this.setState({
      childrenDrawer: true,
    });
  };

  onChildrenDrawerClose = () => {
    this.setState({
      childrenDrawer: false,
    });
  };

  activeContent() {
    return;
  }

  inActiveContent() {
    return;
  } */

  constructor(props) {
    super(props);
    this.state = {
      isActive: false,
    };
  }


/*   static getDerivedStateFromProps(props, state) {
    if (props.location !== state.lastLocation) {
      return {
        searchState: urlToSearchState(props.location),
        lastLocation: props.location,
      };
    }

    return null;
  } */

/*   onSearchStateChange = (searchState) => {
    clearTimeout(this.debouncedSetState);

    this.debouncedSetState = setTimeout(() => {
      this.props.history.push(
        searchStateToUrl(this.props, searchState),
        searchState
      );
    }, DEBOUNCE_TIME);

    this.setState({ searchState });
  };
 */
  render() {
/*     const activeVariable = this.activeContent();
    const inactiveVariable = this.inActiveContent(); */
    const { value } = this.state;

/*     const ssrLocation = this.props;
    console.log('ssrLocation', ssrLocation); */

    return (
      <div className="ais-InstantSearch container">
        {/* {this.state.isActive ? activeVariable : inactiveVariable} */}
        {/*<UsingStateVariables />*/}
        <InstantSearch
          searchClient={searchClient}
          indexName={algolia.indexName}
          refresh
        >
{/*         <InstantSearch
          searchClient={searchClient}
          indexName={algolia.indexName}
          searchState={this.state.searchState}
          onSearchStateChange={this.onSearchStateChange}
          createURL={createURL}
          refresh
        > */}

{/*         <Configure hitsPerPage={280} />

          <Media
            query="(max-width: 1023px)"
            render={() => <Configure hitsPerPage={21} />}
          />
          <Media
            query="(max-width: 950px)"
            render={() => <Configure hitsPerPage={18} />}
          />
          <Media
            query="(max-width: 830px)"
            render={() => <Configure hitsPerPage={20} />}
          />
          <Media
            query="(max-width: 767px)"
            render={() => <Configure hitsPerPage={20} />}
          />
          <Media
            query="(max-width: 676px)"
            render={() => <Configure hitsPerPage={21} />}
          />
          <Media
            query="(max-width: 590px)"
            render={() => <Configure hitsPerPage={21} />}
          />
          <Media
            query="(max-width: 450px)"
            render={() => <Configure hitsPerPage={18} />}
          />
          <Media
            query="(max-width: 350px)"
            render={() => <Configure hitsPerPage={12} />}
          /> */}
          <Media
            query="(min-width: 5120px)"
            render={() => <Configure hitsPerPage={286} />}
          />
          <Media
            query="(min-width: 3440px)"
            render={() => <Configure hitsPerPage={188} />}
          />
          <Media
            query="(min-width: 2200px)"
            render={() => <Configure hitsPerPage={152} />}
          />
          <Media
            query="(min-width: 1750px) and (max-width: 2199px)"
            render={() => <Configure hitsPerPage={70} />}
          />
          <Media
            query="(min-width: 1550px) and (max-width: 1749px)"
            render={() => <Configure hitsPerPage={62} />}
          />
          <Media
            query="(min-width: 1300px) and (max-width: 1549px)"
            render={() => <Configure hitsPerPage={54} />}
          />
          <Media
            query="(min-width: 1100px) and (max-width: 1299px)"
            render={() => <Configure hitsPerPage={32} />}
          />
          <Media
            query="(min-width: 768px) and (max-width: 1099px)"
            render={() => <Configure hitsPerPage={24} />}
          />
          <Media
            query="(max-width: 1023px)"
            render={() => <Configure hitsPerPage={21} />}
          />
          <Media
            query="(max-width: 950px)"
            render={() => <Configure hitsPerPage={18} />}
          />
          <Media
            query="(max-width: 830px)"
            render={() => <Configure hitsPerPage={20} />}
          />
          <Media
            query="(max-width: 767px)"
            render={() => <Configure hitsPerPage={20} />}
          />
          <Media
            query="(max-width: 676px)"
            render={() => <Configure hitsPerPage={21} />}
          />
          <Media
            query="(max-width: 590px)"
            render={() => <Configure hitsPerPage={21} />}
          />
          <Media
            query="(max-width: 450px)"
            render={() => <Configure hitsPerPage={18} />}
          />
          <Media
            query="(max-width: 350px)"
            render={() => <Configure hitsPerPage={12} />}
          />

          {/* <FilterMenus /> */}
          {/*<SearchableRefinementOptions />*/}
          <SearchResultStats />

{/*           <Tooltip
            title='Please note that this only clears all the filters you current have selected, it does not reset the search field or the sort order.'
            align="center"
          > */}
            {/* <ClearRefinements clearsQuery /> */}
{/*           </Tooltip> */}

          {/* <CustomClearAll clearsQuery/> */}

          {/*<MyChamps heading="My Champs" />*/}

          <CurrentRefinements />

          <DebouncedSearchBox delay={1000} />

          <SortBy
            defaultRefinement="RaidTierList"
            items={[
              {
                value: 'RaidTierList',
                label: 'Sort by Rating',
              },
              {
                value: 'RaidTierList_by_rarity',
                label: 'Sort by Rarity' 
              },
              {
                value: 'RaidTierList_by_name',
                label: 'Sort by Champion Name'
              },
              {
                value: 'RaidTierList_by_type',
                label: 'Sort by Champion Type',
              },
              {
                value: 'RaidTierList_by_affinity',
                label: 'Sort by Affinity',
              },
              { value: 'RaidTierList_by_auraStat', label: 'Sort by Aura' },
              {
                value: 'RaidTierList_by_faction',
                label: 'Sort by Faction',
              },
            ]}
          />
          {/*{ value: 'Champions_by_birthTime', label: 'Sort by Date Added' },*/}

          <Tooltip
            title='Click here to toggle between viewing all the champs in the game or viewing only champs that you own. This will not work unless you have uploaded your account data using the "My Champs" page.'
            align="center"
          >
            {/* <div className="MyChampsOnlyToggle">
              <span className="AllChamps">All Champs</span>{' '}
              <Switch onChange={onChange} />{' '}
              <span className="MyChampsOnly">My Champs</span>
            </div> */}
          </Tooltip>

          <div className="mouse-over-info">
            Mouse over items on champion images for an explanation...
          </div>

          {/* <div className="center m-4">
            <Loader type="Bars" color="#e8c817" secondaryColor="#65DBEC" height={80} width={80} timeout={3000} />
          </div> */}
          <div className="center">
            {/* <Loader type="MutatingDots" color="#e8c817" secondaryColor="#65DBEC" height={100} width={100} timeout={1500} /> */}
          </div>

          <div className="champion-panel">
            <Hits hitComponent={AlgoliaHits} />
{/*             <Router ssrLocation={ssrLocation}>
              <Route
                path="/"
                component={AlgoliaInstantSearchCreateURLRefinementLists}
              />
            </Router> */}
          </div>
          <Pagination />
        </InstantSearch>
        <div className="algolia-logo-wrap">
          <GitHubImages
            whichDirectory="AvatarIconImages/RaidChamps"
            whichImage="algolia"
            title="Search by Algolia"
            alt="Search by Algolia"
          />
        </div>
      </div>
    );
  }
}

/* const CustomClearAll = connectCurrentRefinements(({query}) => <div>{query}</div>); */

function Hit(props) {
  return (
    <div>
      <Highlight attribute="title" hit={props.hit} />
    </div>
  );
}

Hit.propTypes = {
  hit: PropTypes.object.isRequired,
};

HomePageWithQueryParams.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
  location: PropTypes.object.isRequired,
};

export default HomePageWithQueryParams;
